import React, { useMemo } from "react";
import { SubTitleTab } from "../../../../../../../component/page-components";
import Dragger from "../../../../../../../component/dragger/Dragger";
import { IconDeleteImg, ProfileKosong } from "../../../../../../../asset";
import { getImgName } from "../../../../../../../util";
import DropdownListLicenseType from "../../../../../../../component/dropdown-list/ddl-license-type";
import { Col, DatePicker, Input, Row } from "antd";
import DropdownSearchSkillset from "../../../../../../../component/dropdown-search/dds-skillset";
import onKeyPressNumber from "../../../../../../../util/onKeyPressNumber";
import DropdownSearchTemperatureCategory from "../../../../../../../component/dropdown-search/dds-temperature-category";

const TabFleetDetailOutsources = ({
  PhotoDriverLicense,
  setDriverLicensePhoto,
  licenseTypeId,
  setLicenseTypeId,
  FormInput,
  depotId,
  skillSetId,
  setSkillSetId,
  FormInputNumber,
  FormInputDate,
  clearCurrImgDriverLicense,
  setTempCategoryId,
  tempCategoryId,
  handleInputForm,
  handleFormInputNumber,
  handleChangeDate,
}) => {
  const NewPhotoDriverLicense = useMemo(() => {
    if (PhotoDriverLicense || PhotoDriverLicense !== "") {
      return typeof PhotoDriverLicense;
    }
    return "";
  }, [PhotoDriverLicense]);
  return (
    <>
      <div className="flex mt-5">
        <div className="basis-1/2">
          <span className="sub-title-pages">Fleet Detail</span>
          <div className="columns mt-5">
            <div className="container-field">
              <SubTitleTab title="Driver License Photo (Option)" />
              {!PhotoDriverLicense || PhotoDriverLicense === "" ? (
                <Dragger
                  selectedFileList={PhotoDriverLicense}
                  setSelectedFileList={setDriverLicensePhoto}
                />
              ) : (
                <div className="border-2 w-full h-[118px] px-[24px] py-[12px] border-dashed rounded-md">
                  <div className="border-2 w-full h-[90px] rounded-md flex justify-between items-center p-[12px]">
                    <div className="w-[66px] h-[66px] border ">
                      <img
                        id="company-logo"
                        className="w-[66px] h-[66px]"
                        src={
                          PhotoDriverLicense !== "" &&
                          NewPhotoDriverLicense === "string"
                            ? PhotoDriverLicense
                            : PhotoDriverLicense && PhotoDriverLicense.length
                            ? URL.createObjectURL(
                                PhotoDriverLicense[0].originFileObj
                              )
                            : ProfileKosong
                        }
                        alt="company-logos"
                      />
                    </div>
                    <div
                      id="image-name"
                      className="font-roboto font-normal text-sm text-black-300"
                    >
                      {NewPhotoDriverLicense === "string"
                        ? getImgName(PhotoDriverLicense)
                        : NewPhotoDriverLicense === "object"
                        ? PhotoDriverLicense[0]?.name
                        : "Tidak Ada Foto"}
                    </div>
                    <div>
                      <img
                        id="icon-delete-images"
                        className="cursor-pointer"
                        src={IconDeleteImg}
                        alt="delete-icon"
                        onClick={clearCurrImgDriverLicense}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="container-field">
              <SubTitleTab title="License Type" />
              <DropdownListLicenseType
                placeholder={"Select License Type"}
                valueDDS={licenseTypeId}
                setValueDDS={setLicenseTypeId}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="License ID" />
              <Input
                style={{ width: "100%" }}
                size="large"
                placeholder="Autogenerate"
                disabled
                value={FormInput?.license_id}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="License Number" />
              <Input
                style={{ width: "100%" }}
                size="large"
                placeholder="Type License Number"
                value={FormInput?.driving_license_no}
                onKeyPress={(e) => onKeyPressNumber(e)}
                onChange={(evt) =>
                  handleInputForm(evt.target.value, "driving_license_no")
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Validity Period of Driving License" />
              <DatePicker
                style={{ width: "100%" }}
                size="large"
                placeholder="Select Date"
                value={FormInputDate?.license_validity}
                onChange={(evt) => handleChangeDate(evt, "license_validity")}
                format={"DD MMMM YYYY"}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Vehicle Type (Optional)" />
              <Input
                style={{ width: "100%" }}
                size="large"
                placeholder="Type Vehicle Type"
                value={FormInput?.vehicle_type}
                onChange={(evt) =>
                  handleInputForm(evt.target.value, "vehicle_type")
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Vehicle Model (Optional)" />
              <Input
                style={{ width: "100%" }}
                size="large"
                placeholder="Type Vehicle Model"
                value={FormInput?.model}
                onChange={(evt) => handleInputForm(evt.target.value, "model")}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Vehicle No" />
              <Input
                style={{ width: "100%" }}
                size="large"
                placeholder="Type Vehicle No"
                value={FormInput?.vehicle_no}
                onChange={(evt) =>
                  handleInputForm(evt.target.value, "vehicle_no")
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Temperature Category" />
              <DropdownSearchTemperatureCategory
                placeholder={"Select Temperature Category"}
                valueDDS={tempCategoryId}
                setValueDDS={setTempCategoryId}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Skill Set" />
              <DropdownSearchSkillset
                depotId={depotId}
                placeholder={"Select Skillset"}
                valueDDS={skillSetId}
                setValueDDS={setSkillSetId}
              />
            </div>
             
      <div className="container-field">
        <SubTitleTab title="Total Range Distance" />
        <Input
          addonAfter="Km"
          size="large"
          value={FormInput?.total_range_distance}
          disabled
        />
      </div>
          </div>
        </div>
        <div className="basis-1/2">
          <span className="sub-title-pages">Order Specification</span>
          <div className="columns mt-5">
            <Row>
              <Col span={12} className="pr-2 ">
                <div className="container-field">
                  <SubTitleTab title="Min Unit" />
                  <Input
                    size="large"
                    placeholder="Type Min Unit"
                    addonAfter="Pcs"
                    onKeyPress={(e) => onKeyPressNumber(e)}
                    value={FormInputNumber?.min_order_unit}
                    onChange={(evt) =>
                      handleFormInputNumber(
                        Number(evt.target.value),
                        "min_order_unit"
                      )
                    }
                  />
                </div>
              </Col>
              <Col span={12}>
                <div className="container-field">
                  <SubTitleTab title="Max Unit" />
                  <Input
                    size="large"
                    placeholder="Type Max Unit"
                    addonAfter="Pcs"
                    onKeyPress={(e) => onKeyPressNumber(e)}
                    value={FormInputNumber?.max_order_unit}
                    onChange={(evt) =>
                      handleFormInputNumber(
                        Number(evt.target.value),
                        "max_order_unit"
                      )
                    }
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={12} className="pr-2 ">
                <div className="container-field">
                  <SubTitleTab title="Min Weight" />
                  <Input
                    size="large"
                    placeholder="Type Min Weight"
                    addonAfter="Pcs"
                    onKeyPress={(e) => onKeyPressNumber(e)}
                    value={FormInputNumber?.min_order_weight}
                    onChange={(evt) =>
                      handleFormInputNumber(
                        Number(evt.target.value),
                        "min_order_weight"
                      )
                    }
                  />
                </div>
              </Col>
              <Col span={12}>
                <div className="container-field">
                  <SubTitleTab title="Max Weight" />
                  <Input
                    size="large"
                    placeholder="Type Max Weight"
                    addonAfter="Pcs"
                    onKeyPress={(e) => onKeyPressNumber(e)}
                    value={FormInputNumber?.max_order_weight}
                    onChange={(evt) =>
                      handleFormInputNumber(
                        Number(evt.target.value),
                        "max_order_weight"
                      )
                    }
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={12} className="pr-2 ">
                <div className="container-field">
                  <SubTitleTab title="Min Volume" />
                  <Input
                    size="large"
                    placeholder="Type Min Volume"
                    addonAfter="Pcs"
                    onKeyPress={(e) => onKeyPressNumber(e)}
                    value={FormInputNumber?.min_order_volume}
                    onChange={(evt) =>
                      handleFormInputNumber(
                        Number(evt.target.value),
                        "min_order_volume"
                      )
                    }
                  />
                </div>
              </Col>
              <Col span={12}>
                <div className="container-field">
                  <SubTitleTab title="Max Volume" />
                  <Input
                    size="large"
                    placeholder="Type Max Volume"
                    addonAfter="Pcs"
                    onKeyPress={(e) => onKeyPressNumber(e)}
                    value={FormInputNumber?.max_order_volume}
                    onChange={(evt) =>
                      handleFormInputNumber(
                        Number(evt.target.value),
                        "max_order_volume"
                      )
                    }
                  />
                </div>
              </Col>
            </Row>
            <div className="container-field">
              <SubTitleTab title="Fix Cost" />
              <Input
                addonBefore="IDR"
                size="large"
                placeholder="Type Fix Cost"
                onKeyPress={(e) => onKeyPressNumber(e)}
                value={
                  FormInputNumber?.fixed_cost ? FormInputNumber?.fixed_cost : ""
                }
                onChange={(evt) =>
                  handleFormInputNumber(Number(evt.target.value), "fixed_cost")
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Variable Cost Per Km (Optional)" />
              <Input
                addonBefore="IDR"
                size="large"
                placeholder="Type Variable Cost Per Km"
                onKeyPress={(e) => onKeyPressNumber(e)}
                value={
                  FormInputNumber?.variable_cost
                    ? FormInputNumber?.variable_cost
                    : ""
                }
                onChange={(evt) =>
                  handleFormInputNumber(
                    Number(evt.target.value),
                    "variable_cost"
                  )
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Transporter Time Cost (Optional)" />
              <Input
                addonBefore="IDR"
                size="large"
                placeholder="Type Transporter Cost"
                onKeyPress={(e) => onKeyPressNumber(e)}
                value={
                  FormInputNumber?.transporter_time_cost
                    ? FormInputNumber?.transporter_time_cost
                    : ""
                }
                onChange={(evt) =>
                  handleFormInputNumber(
                    Number(evt.target.value),
                    "transporter_time_cost"
                  )
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Waiting Time Cost (Optional)" />
              <Input
                addonBefore="IDR"
                size="large"
                placeholder="Type Waiting Time Cost"
                onKeyPress={(e) => onKeyPressNumber(e)}
                value={
                  FormInputNumber?.waiting_time_cost
                    ? FormInputNumber?.waiting_time_cost
                    : ""
                }
                onChange={(evt) =>
                  handleFormInputNumber(
                    Number(evt.target.value),
                    "waiting_time_cost"
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TabFleetDetailOutsources;
